import React, { useEffect, useCallback, useRef } from "react";
import styled, { keyframes } from "styled-components";

const inAnimation = keyframes`
    from {opacity: 0; transform: translateY(-1rem);}
    to {opacity: 1; transform: translateY(0);}
`;

const DropdownWrap = styled.div`
    background-color: var(--color-white, white);
    border: 1px solid var(--color-gray-20, #ebebeb);
    box-sizing: border-box;
    box-shadow: var(---shadow-lg);
    color: var(--color-gray-60, black);
    position: absolute;
    max-width: 20rem;
    overflow: hidden;
    z-index: 1;
    animation: ${inAnimation} .5s forwards;
`;

const DropdownContent = styled.div`
    max-height: 25rem;
    overflow: hidden;
    overflow-y: auto;
    label, button {
        border: none;
        border-bottom: 1px solid var(--color-gray-10, lightgray);
        &:hover {
            background-color: var(--color-gray-10, lightgray);
        }
    }
`;

interface DropdownProps
{
    open: boolean;
    setOpen: (isOpen: boolean) => void;
}

const Dropdown: React.FunctionComponent<DropdownProps> = (props) =>
{
    if (!props.open)
    {
        return null;
    }

    const handleClickOutside = useCallback(() => props.setOpen(false), [props]);

    const ref = useRef(document.createElement("div"));

    const handleClick = useCallback((event) =>
    {
        if (ref.current !== null)
        {
            if (ref.current && !ref.current.contains(event.target))
            {
                handleClickOutside();
            }
        }
    }, [ref, handleClickOutside]);

    useEffect(() =>
    {
        if (props.open)
        {
            document.addEventListener("mousedown", handleClick);
        }
        else
        {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () =>
        {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [props.open, handleClickOutside, handleClick]);

    return (
        <DropdownWrap {...props} ref={ref}>
            <DropdownContent className="scrollbar">
                {props.children}
            </DropdownContent>
        </DropdownWrap>
    );
};

export default Dropdown;